import { createContext } from 'react';

const GridColumnsContext = createContext([]);

export default GridColumnsContext;
